import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import './message-dialog.styles.scss';

const handleClose = (onClose: any) => {
  onClose();
}
export const MessageDialog = (props: any) => {


  const getBGStyle = () => {
    return 'lockedDialogContainer bg-vertical';
  }

  return (
    <Dialog {...props}
      PaperProps={{
        style: {
          backgroundColor: 'transparent', boxShadow: 'none',
        },
      }}>
      <div className={getBGStyle()}>
        {/* <img src="/assets/images/site/ok-msg.png" alt=""/> */}
        <div className="message-box-animation"></div>
        <div className="loginMessage">{props.message}</div>
        <div className="loginButton">
          <Button variant="contained" onClick={() => { handleClose(props.onClose) }} color="primary">Ok</Button>
        </div>
      </div>
    </Dialog>
  );
}




export default MessageDialog;